module.exports = __webpack_public_path__ + "img/no-matches.b9a1c4d1.png";